import { FunctionComponent } from 'react';
import { MinutesSelect } from '../minutes-select';
import { HourSelect } from '../hour-select';
import { TabCronProp } from '@/types/cron';
import { INPUT_FIELD_CLASSNAME } from '@/constants/classname/classname';

const DailyCron: FunctionComponent<TabCronProp> = (props) => {

    const onDayChange = (e: { target: { value: string } }) => {
        if (props.disabled) { return }
        if (!e.target.value || (parseInt(e.target.value) > 0 && parseInt(e.target.value) < 32)) {
            onValueChange(3, (e.target.value ? `1/${e.target.value}` : e.target.value));
        }
    }

    const onAtHourChange = (e: { target: { value: string } }) => {
        if (props.disabled) { return }
        onValueChange(2, e.target.value);
    }

    const onAtMinuteChange = (e: { target: { value: string } }) => {
        if (props.disabled) { return }
        onValueChange(1, e.target.value);
    }

    const onValueChange = (cronPosition: number, value: string) => {
        const val = props.value;
        val[cronPosition] = value;
        props.onChange(val);
    }

    return (
        <div className="daily py-4">
            <div className='text-left font-semibold text-base mb-1'>
                {props.translate('Every')}
            </div>
            <div className='w-full flex flex-row items-center'>
                <input
                    className={INPUT_FIELD_CLASSNAME + ' w-[120px]'}
                    disabled={props.disabled}
                    type="Number"
                    maxLength={2}
                    onChange={onDayChange}
                    value={props.value[3]?.split('/')[1] ? props.value[3].split('/')[1] : ''}
                />
                <span className='text-base ml-2'>{props.translate('day(s)')}</span>
            </div>
            <div className='my-4' />
            <div className='text-left font-semibold text-base mb-1'>
                Start Time
            </div>
            <div className='w-full flex flex-row items-center'>
                <HourSelect
                    onChange={onAtHourChange}
                    value={props.value[2]}
                    disabled={props.disabled}
                />
                <div className='mx-4 font-bold'>:</div>
                <MinutesSelect
                    onChange={onAtMinuteChange}
                    value={props.value[1]}
                    disabled={props.disabled}
                />
            </div>
        </div>
    )
}
export default DailyCron;
